import React from 'react';

import { ReviewAlertPreference } from 'types/communities';

import {
  formatReviewCategoryCountLabel,
  getOverallReviewAlertPreference,
  hasAllReviewCategoriesSelected,
} from './utils';

type Props = {
  preferences: ReviewAlertPreference[] | undefined;
  allReviewCategoryIds: number[];
};

const CommunityReviewAlertCategoriesLabel = ({ preferences, allReviewCategoryIds }: Props) => {
  if (!Array.isArray(preferences) || preferences.length === 0) {
    return null;
  }

  const overallPreference = getOverallReviewAlertPreference(preferences);
  if (overallPreference) {
    return (
      <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.25, fontSize: 12 }}>
        <span>Overall</span>
        <span style={{ color: 'var(--text-secondary)' }}>
          {overallPreference.number_of_reviews}+ {overallPreference.positive ? 'Positive' : 'Negative'}{' '}
          {overallPreference.within_months} {overallPreference.within_months === 1 ? 'Month' : 'Months'}
        </span>
      </span>
    );
  }

  if (hasAllReviewCategoriesSelected(preferences, allReviewCategoryIds)) {
    return <span>All Categories</span>;
  }

  return <span>{formatReviewCategoryCountLabel(preferences.length)}</span>;
};

export default CommunityReviewAlertCategoriesLabel;
